import Vue from 'vue'
import Vuex from 'vuex'
import ImageApiRequest from '@/store/catalog/imageApiRequest'
import Notifications from '@/store/notifications/notifications'

Vue.use(Vuex)

export interface BoundaryBoxInterface {
  x1: number,
  y1: number,
  x2: number,
  y2: number,
  categoryId: number,
  categoryName: string,
  score: number
}

export default new Vuex.Store({
  state: () => ({
    foundElements: [],
    elementsNumber: 0,
    width: 0,
    height: 0,
    loading: false,
    catalogId: '',
    imageId: '',
    url: '',
    urlBase64: '',
  }),
  mutations: {
    setCatalogId: (state: any, catalogId: string) => {
      state.catalogId = catalogId
    },
    setImageId: (state: any, imageId: string) => {
      state.imageId = imageId
    },
    setFoundElements: (state: any, found: { foundElements: BoundaryBoxInterface[], count: number }) => {
      state.foundElements = found.foundElements
      state.elementsNumber = found.count
    },
    setMetadata: (state: any, data: any) => {
      state.url = data.url
      state.urlBase64 = data.urlBase64
      state.width = data.w
      state.height = data.h
    },
    setLoading: (state: any, loading: boolean) => {
      state.loading = loading
    },
  },
  actions: {
    getImageFoundElements(context: any) {
      context.commit('setLoading', true)

      ImageApiRequest.getImageFoundElements(
        {
          catalogId: context.state.catalogId,
          imageId: context.state.imageId,
        },
      ).then(result => {
        if (result.status === 200) {
          context.commit('setFoundElements', { foundElements: result.data.b_box, count: result.data.b_box_count })
          context.commit('setMetadata', result.data)
        }
        context.commit('setLoading', false)
        return result
      }).catch(error => {
        Notifications.commit('addError', error, { root: true })
        context.commit('setLoading', false)
      })
    },
  },
})
